export default function() {
    return {
        customers: [],
        page: 1,
        totalPages: 0,
        perPage: 15,
        searchParams: {
            trip: null,
            customerName: null,
            customerDocument: null,
            customerPhone: null,
        },
        idTrip: null,
        search: {},
        fields: [
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'cpf',
                label: 'CPF'
            },
            {
                key: 'phone',
                label: 'Telefone'
            },
            {
                key: 'countTrip',
                label: 'Contador de viagens'
            }
        ]
    }
}
